import { render, staticRenderFns } from "./customerTab.vue?vue&type=template&id=fa57dede&scoped=true&"
import script from "./customerTab.vue?vue&type=script&lang=js&"
export * from "./customerTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa57dede",
  null
  
)

export default component.exports